export default class SearchForm {
	constructor() {
		this.init();
	}

	init() {
		let searchFieldElement = document.querySelectorAll( '[data-search-form="element"]' );

		searchFieldElement.forEach( ( element ) => {
			let input = element.querySelector( '[data-search-form="input"]'),
			button = element.querySelector( '[data-search-form="button"]');

			button.addEventListener( 'click', (e) => {
				if ( document.body.classList.contains( 'search-opened' ) === false ) {
					e.preventDefault();
					input.focus();
					document.body.classList.add( 'search-opened' );
				}
			} );

			input.addEventListener( 'blur', (e) => {
				document.body.classList.remove( 'search-opened' );
			} );
		} );
	}
}
